import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { editGroup, getGroup, getGroups } from '../../../redux/actions/groupsActions'
import TextFieldGroup from '../../common/TextFieldGroup'
import Header from '../../layout/Partials/Header'

import Loading from '../../common/Loading'
import TextAreaFieldGroup from '../../common/TextAreaFieldGroup'
import { Theme } from '../../../utils/Theme'
import { withStyles } from '@material-ui/styles'
import AdminLayout from '../../layout/AdminLayout'
import Section from '../../UI/Section'

const styles = Theme()

class EditGroup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      owner: this.props.auth.user.id,
      name: '',
      description: '',
      errors: {},
    }

    this.onChange = this.onChange.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    //CHECK FOR ERRORS
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors })
    }

    if (nextProps.groups.group) {
      const group = nextProps.groups.group

      this.setState({
        name: group.name,
        description: group.description,
      })
    }
  }

  componentDidMount() {
    this.props.getGroup(this.props.match.params.id)

    //	TODO : ADD GROUPS DROPDOWN OPTIONS
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value })
  }

  onSubmit(e) {
    e.preventDefault()

    const groupData = {
      owner: this.props.auth.user.id,
      name: this.state.name,
      description: this.state.description,
    }

    this.props.editGroup(this.props.match.params.id, groupData, this.props.history)
  }

  render() {
    const { errors } = this.state
    const { groups, classes } = this.props

    return (
      <AdminLayout>
        <div className="o-group">
          <Header>
            <h2 className="c-navbar__title">Edit Group</h2>
          </Header>
          <div className="u-m-small">
            {groups.loading || (groups.group === null && <Loading />)}
            {!groups.loading && groups.group && (
              <Section>
                <div className="full_height u-pv-small">
                  <div className="">
                    <div className="u-p-medium">
                      <div className="o-line">
                        <h4 className={`c-card__title ${classes.colorSecondary}`}>Edit Security Group</h4>
                        <button
                          onClick={() => this.props.history.goBack()}
                          className={`c-btn ${classes.buttonSecondary}`}
                        >
                          Cancel
                        </button>
                      </div>

                      <hr className="u-mt-small u-mb-medium" />
                      <form noValidate onSubmit={this.onSubmit}>
                        <div className="row">
                          <div className="col-md-6">
                            <TextFieldGroup
                              label="Group Name"
                              type="text"
                              onChange={this.onChange}
                              value={this.state.name}
                              name="name"
                              error={errors.name}
                            />
                          </div>
                          <div className="col-md-12">
                            <TextAreaFieldGroup
                              label="Description"
                              type="text"
                              onChange={this.onChange}
                              value={this.state.description}
                              name="description"
                              error={errors.description}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6 u-mt-xsmall">
                            <button type={'submit'} className={`c-btn  ${classes.buttonPrimary}`}>
                              Update Group
                            </button>
                          </div>

                          <div className="col-md-6 u-mt-xsmall u-text-right">
                            <button
                              type={'button'}
                              onClick={() => {
                                this.setState({
                                  name: '',
                                  description: '',
                                })
                              }}
                              className={`c-btn ${classes.buttonSecondary}`}
                            >
                              Clear
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </Section>
            )}
          </div>
        </div>
      </AdminLayout>
    )
  }
}

EditGroup.propTypes = {
  auth: PropTypes.object.isRequired,
  groups: PropTypes.object.isRequired,
  editGroup: PropTypes.func.isRequired,
  getGroup: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  match: PropTypes.object,
  classes: PropTypes.object,
  history: PropTypes.object,
}

const mapStateToProps = state => ({
  auth: state.auth,
  groups: state.groups,
  errors: state.errors,
})

export default connect(mapStateToProps, {
  editGroup,
  getGroups,
  getGroup,
})(withRouter(withStyles(styles)(EditGroup)))
